export const ASCEND = "ascend";
export const DECEND = "descend";

export const SORT_DIRECTIONS = [ASCEND, DECEND];
export const SORT_DIRECTIONS_ASC_DESC_ASC = [ASCEND, DECEND, null];

export const getSortingChanges = (sorting, sorter) => {
  let { order: nextSortBy, columnKey: nextColumnName } = sorter;
  const columnIschanged = nextColumnName !== sorter.columnName;

  const prevSortBy = sorting.order;
  const sortDirectionIschanged = prevSortBy !== nextSortBy;

  return { columnIschanged, sortDirectionIschanged, nextColumnName, nextSortBy };
};

export const getColumnSortOrder = (sorting, columnName) => {
  if (sorting?.columnKey === columnName) {
    if (sorting.order === ASCEND) {
      return ASCEND;
    } else if (sorting.order === DECEND) {
      return DECEND;
    }
  }
};

export const apiSortOptions = {
  desc: "DESC",
  asc: "ASC"
};
